module.exports = __webpack_public_path__ + "assets/img/冒险岛.8cb411bc.png";